import { useMemo, useState } from "react";
import { X } from "lucide-react";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const money = n => new Intl.NumberFormat("tr-TR", { style: "currency", currency: "TRY" }).format(n || 0);
export const fmtD = d => { if (!d) return "—"; const s = String(d).slice(0, 10).split("-"); return s.length === 3 ? `${s[2]}.${s[1]}.${s[0]}` : d; };
export const fmtDT = d => d ? new Date(d).toLocaleString("tr-TR", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "—";
export const todayStr = () => { const d = new Date(); d.setMinutes(d.getMinutes() - d.getTimezoneOffset()); return d.toISOString().slice(0, 10); };
export const ACC = { nakit: "Nakit Kasa", banka: "Banka", pos: "POS (Kredi Kartı)", cek: "Çek/Senet Portföyü" };
export const PAY_ACCOUNTS = [["nakit", "Nakit"], ["banka", "Banka / Havale"], ["pos", "Kredi Kartı (POS)"]];
export const errMsg = e => e?.response?.data?.detail || e?.message || "Hata";

export function FinModal({ title, close, children, testid }) {
  return <div className="overlay"><div className="modal" data-testid={testid}><div className="modal-head"><h3>{title}</h3><button data-testid="fin-modal-close" className="icon-button" onClick={close}><X size={19} /></button></div>{children}</div></div>;
}

export function PartySelect({ parties, value, onChange, testid, placeholder, required = true }) {
  const [q, setQ] = useState("");
  const list = useMemo(() => { const s = q.toLowerCase().trim(); return (s ? parties.filter(p => ((p.name || "") + " " + (p.phone || "")).toLowerCase().includes(s)) : parties).slice(0, 300); }, [parties, q]);
  const sel = parties.find(p => p.id === value);
  return <div className="product-picker">
    <input data-testid={`${testid}-search`} className="pp-search" placeholder={placeholder} value={q} onChange={e => setQ(e.target.value)} />
    <select data-testid={testid} value={value} onChange={e => onChange(e.target.value)} required={required}>
      <option value="">— Seçin —</option>
      {sel && !list.some(p => p.id === value) && <option value={value}>✓ {sel.name}</option>}
      {list.map(p => <option key={p.id} value={p.id}>{p.name} · Bakiye {money(p.balance || 0)}</option>)}
    </select>
  </div>;
}

export function AccountSelect({ value, onChange, testid }) {
  return <div className="pay-tabs fin-acc-tabs" data-testid={testid}>
    {PAY_ACCOUNTS.map(([v, l]) => <button type="button" key={v} data-testid={`${testid}-${v}`} className={value === v ? "selected" : ""} onClick={() => onChange(v)}>{l}</button>)}
  </div>;
}
